import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'AssemblyThawList',
  data: function data() {
    return {
      title: null,
      isSelect: this.checkauthority('select_jd_list'),
      selectForm: {
        noOrPhone: null
      },
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      sex: [],
      memberV: [],
      memberTypes: []
    };
  },
  methods: {
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    initEunmData: function initEunmData() {
      this.getSexEnumList('member_sex');
      this.getMemberVList('member_v');
      this.getMemberTypeList('member_type');
    },
    changeVac: function changeVac(type) {
      return this.enums.checkEnumsValue(this.memberV, type, '-');
    },
    changeMemberType: function changeMemberType(type) {
      return this.enums.checkEnumsValue(this.memberTypes, type, '-');
    },
    changeSex: function changeSex(type) {
      return this.enums.checkEnumsValue(this.sex, type, '-');
    },
    getMemberTypeList: function getMemberTypeList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.memberTypes = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getMemberVList: function getMemberVList(name) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.memberV = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getSexEnumList: function getSexEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: name
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.sex = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getEnumList: function getEnumList(name) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: name
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this4.enumList = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this5 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.daleteApi(index, data);
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    daleteApi: function daleteApi(index, data) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                freezeId: data.freezeId
              };
              _context5.n = 1;
              return api.DELETE_MEMBERFREEZERECORDS(par);
            case 1:
              _this6.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.DELETE_BATCH_MEMBERFREEZERECORDS(par);
            case 1:
              _this7.$message.success('操作成功');
              _this7.initTableData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this8 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this8.tableSelects.forEach(function (element) {
          par.push(element.freezeId);
        });
        _this8.deleteBatchApi(par);
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    updateApi: function updateApi(data) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var pro;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              pro = {
                freezeId: data.freezeId,
                type: 1,
                memberId: data.memberId
              };
              _context7.n = 1;
              return api.UPDATE_MEMBERFREEZERECORDS(pro);
            case 1:
              _this9.initTableData();
              _this9.$message.success('解除成功');
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      var _this0 = this;
      this.$confirm('确定解除冻结吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this0.updateApi(data);
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: '已取消冻结'
        });
      });
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this1.initEunmData();
              par = {
                pageNo: _this1.pageNo,
                pageSize: _this1.pageSize,
                noOrPhone: _this1.selectForm.noOrPhone
              };
              _context8.n = 1;
              return api.GET_MEMBERFREEZERECORDS_TAWN_PAGE_LIST(par);
            case 1:
              res = _context8.v;
              _this1.tableData = res.body.datas;
              _this1.pageTotal = res.body.sumDataCount;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    this.initTableData();
  }
};